import React, { ReactElement } from 'react';
import { PageContent } from './page-content';
import { PageType, PageDataParams, EvalData, SFFProblemType } from 'its-pages';
import { SelfEval } from '../containers/self-eval';
import { PeerEval } from '../containers/peer-eval';

export class EvalContent extends PageContent {
  private _component: any;
  private _hint: ReactElement;

  public get component() {
    const pageData = this.pageData;
    return <this._component content={this} key={pageData.seed} />;
  }

  public get pageType(): PageType {
    return PageType.Problem;
  }

  public getSecondTryHint() {
    return <div>{this._hint as any}</div>;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private logAnswers(): void {}

  public constructor(params: PageDataParams) {
    super(new EvalData(params));

    if (this.pageData.type === SFFProblemType.SelfEval) {
      this._component = SelfEval;
      this._hint = (
        <p>
          You{"'"}ve identified that there were some less than ideal attributes
          in your response. Please rewrite your response addressing those
          issues.
        </p>
      );
    } else {
      this._component = PeerEval;
      this._hint = <p>Rewrite the therapist response in your own words.</p>;
    }
    this.logAnswers();
  }
}
